<template>
    <o-form-wrapper
        :form-state="formState"
        :schema="schema"
        :server-errors="_se"
        :v="$v.item"
        v-model="item"
    >
        <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="name"
        >
            <o-text-field
                :form-state="formState"
                :server-errors="_se"
                :validators="$v.item"
                name="name"
                v-bind="schema.fields.name"
                v-model="item.name"
            ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="permissions"
        >
            <div style="overflow-y: scroll; overflow-x: hidden; height: 200px">
                <o-multi-checkbox
                    :form-state="formState"
                    :items="optionPermissionItems"
                    :loading="optionPermissionWorking"
                    :server-errors="_se"
                    :validators="$v.item"
                    multiple
                    name="permissions"
                    sort-field="name"
                    text-field="name"
                    v-bind="schema.fields.permissions"
                    v-model="item.permissions"
                    value-field="id"
                >
                </o-multi-checkbox>
            </div>
            <!--<permission-form-table v-model="item.permissions"
                                   :validators="$v.item.permissions"
                                   :form-state="formState"
                                   :label="schema.fields.permissions.label"
                                   :level="level+1"
                                   :server-errors="_se.permissions">
            </permission-form-table>-->
            <!-- UNCOMMENT TO USE Cards
            <permission-form-cards v-model="item.permissions"
                :validators="$v.item.permissions"
                :form-state="formState"
                :label="schema.fields.permissions.label"
                :level="level+1"
                :server-errors="_se.permissions">
            </permission-form-cards>
            -->
        </o-widget-wrapper>
    </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../schema/schema_vuetify";
import {
    CreateCodeTableFetchMixin,
    CreateFormStateMixin,
    CreateGroupPermissionMixin,
    VuelidateMixin,
} from "../../../mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../components/forms/OWidgetWrapper";
import OTextField from "../../../components/forms/fields/OTextField";
import OSelect from "../../../components/forms/fields/OSelect";
import OCheckbox from "../../../components/forms/fields/OCheckbox";
import OFormWrapper from "../../../components/forms/OFormWrapper";
import ODateTime from "../../../components/forms/fields/ODateTime";
import { default as PermissionForm } from "../../permission/components/ItemForm";
import OMultiCheckbox from "../../../components/forms/fields/OMultiCheckbox";
// import { default as PermissionFormCards } from '../../permission/components/ItemFormCards';

export default {
    mixins: [
        VuelidateMixin,
        validationMixin,
        CreateFormStateMixin("$v"),
        CreateGroupPermissionMixin("Group"),
        CreateCodeTableFetchMixin(["Permission"]),
    ],
    components: {
        OMultiCheckbox,
        OFormWrapper,
        OWidgetWrapper,
        ODateTime,

        OCheckbox,
        OSelect,
        OTextField,

        PermissionForm,
        //PermissionFormCards,
    },
    props: {
        item: {
            type: Object,
            default: () => {},
        },
        level: { type: Number, default: 0 },
    },
    data: () => ({
        schemaModel: cleanUpModel(schema.Group, {}),
    }),
    methods: {},
    computed: {
        _se() {
            // Return an empty Object if there are no Server Errors to avoid Binding Errors
            return this.serverErrors || {};
        },
    },
    watch: {},
    created() {},
};
</script>
